import * as React from "react";
import {Button} from "react-bootstrap";
import {RouteComponentProps} from "react-router";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {userManager} from "./utils/userManager";

interface OidcLoginButtonProps {
  dispatch: (action) => any;
}

class OidcLoginButtonComponent extends React.Component<OidcLoginButtonProps & RouteComponentProps<any> & InjectedIntlProps> {
  handleLogin = async (event) => {
    event.preventDefault();
    try {
      const data = {
        hash: location.hash.length > 0 ? location.hash : '#',
        urlBeforeRedirection: '/data'
      };
      await userManager.signinRedirect({data});

    } catch (error) {
      throw new Error("Sign in error :" + error);
    }
  }

  render() {
    return (
        <div>

          <Button color="primary" onClick={this.handleLogin}>
            <FormattedMessage id="studio.openid.login-page.button" defaultMessage="OpenID Connect"/>
          </Button>

        </div>
    )
  }
}

export const OidcLoginButton = connect()(withRouter(injectIntl(OidcLoginButtonComponent)));

